import './assets/base.scss'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import KeyCloakService from "./security/KeycloakService";
import HttpService from "@/services/httpservice";
import { isUnderMaintenance } from "@/utils/maintenance.js";
import VueMask from '@devindex/vue-mask';
import VueApexCharts from "vue3-apexcharts";
import DefaultLayout from "./components/layouts/DefaultLayout.vue";
import EmptyLayout from "./components/layouts/EmptyLayout.vue";
import NavbarLayout from "./components/layouts/NavbarLayout.vue";
import Vue3EasyDataTable from 'vue3-easy-data-table';
// import 'vue3-easy-data-table/dist/style.css';
import DraggableModule from "vue3-draggable";
const Draggable = DraggableModule?.default ?? DraggableModule;

import i18n from "@/plugins/i18n.js";
import ErrorReportingService from "@/services/ErrorReportingService";
import { monitorarNovaVersao } from "@/composables/useNovaVersao.js";
import { instalarRecargaPorChunk } from "@/utils/recargaPorChunk.js";
import App from './App.vue'
import router from './router'
import "bootstrap"
// CSS do vue-loading-overlay. Fica AQUI, e não numa view, porque 124 componentes usam o
// componente `<loading>` — inclusive o App.vue, para o overlay de troca de rota. Antes este
// import vivia em views/Usuarios/Colaboradores/UsuarioList.vue: em produção funcionava por
// acidente (`cssCodeSplit: false` junta todo o CSS num arquivo só), mas em DEV o Vite injeta o
// CSS de cada módulo quando o módulo carrega, então o overlay ficava sem estilo — invisível — em
// toda rota, até que alguém abrisse a tela de colaboradores.
// Vem antes de custom.scss de propósito: CSS de terceiro primeiro, overrides do produto por último.
import "vue-loading-overlay/dist/css/index.css";
// Entrada ÚNICA de estilo do produto: reset, tokens, fontes, Bootstrap e o CSS do produto, na
// ordem de cascata documentada lá dentro. Eram três imports (main.css, bootstrap.scss e este),
// com um artefato compilado à mão no meio. Não acrescente outro aqui — o lugar é dentro dela.
import "./assets/custom.scss";







const renderApp = () => {
    const app = createApp(App)
    app.use(createPinia())
    app.component("default-layout", DefaultLayout)
    app.component("empty-layout", EmptyLayout)
    app.component("navbar-layout", NavbarLayout)
  // eslint-disable-next-line vue/multi-word-component-names
    app.component('apexchart', VueApexCharts)
    app.component('EasyDataTable', Vue3EasyDataTable)
  // eslint-disable-next-line vue/multi-word-component-names
    app.component('draggable', Draggable)
    app.use(createPinia())
    app.use(router)
    app.use(i18n) // Use o i18n
    app.use(VueMask)
    ErrorReportingService.install(app, router)
    app.mount('#app')
};

function bootstrap() {
    // Antes de tudo: o primeiro import dinâmico pode acontecer já na navegação inicial.
    instalarRecargaPorChunk();

    // Fora do caminho crítico: é uma ida à rede que não precisa anteceder pixel nenhum.
    // Ao encontrar versão nova, mostra um aviso — quem decide a hora de recarregar é o
    // usuário, não o sistema no meio do que ele está fazendo.
    monitorarNovaVersao();

    // Em manutenção a aplicação sobe sem Keycloak: o guard do router prende tudo em /manutencao,
    // e mandar o usuário para o login antes de ele ver o aviso não faz sentido — nenhuma rota
    // autenticada está acessível de qualquer forma.
    if (isUnderMaintenance) {
        renderApp();
        return;
    }

    KeyCloakService.CallLogin(renderApp);
    HttpService.configureAxiosKeycloak();
}


await bootstrap()
